var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_38_7176",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_38_7176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.667 15.875C12.4303 15.9723 12.2253 15.955 12.052 15.823C11.8787 15.691 11.792 15.493 11.792 15.229C11.792 15.1043 11.8337 14.9793 11.917 14.854C12.0003 14.7293 12.0973 14.639 12.208 14.583C13.0973 14.153 13.8023 13.5213 14.323 12.688C14.8437 11.8547 15.104 10.938 15.104 9.938C15.104 9.29867 14.986 8.68034 14.75 8.083C14.514 7.48634 14.139 6.931 13.625 6.417L13.167 5.958V7.5C13.167 7.68067 13.0973 7.837 12.958 7.969C12.8193 8.101 12.6667 8.167 12.5 8.167C12.3193 8.167 12.163 8.101 12.031 7.969C11.899 7.837 11.833 7.68067 11.833 7.5V4.396C11.833 4.18734 11.9093 4.00334 12.062 3.844C12.2153 3.684 12.403 3.604 12.625 3.604H15.729C15.9097 3.604 16.066 3.67 16.198 3.802C16.33 3.934 16.396 4.09034 16.396 4.271C16.396 4.45167 16.33 4.608 16.198 4.74C16.066 4.872 15.9097 4.938 15.729 4.938H14L14.438 5.375C15.1047 5.97234 15.6047 6.67367 15.938 7.479C16.2713 8.285 16.438 9.10467 16.438 9.938C16.438 11.2433 16.094 12.4273 15.406 13.49C14.7187 14.552 13.8057 15.347 12.667 15.875ZM4.27099 16.396C4.09033 16.396 3.93399 16.33 3.80199 16.198C3.66999 16.066 3.60399 15.9097 3.60399 15.729C3.60399 15.5483 3.66999 15.392 3.80199 15.26C3.93399 15.128 4.09033 15.062 4.27099 15.062H5.97899L5.54199 14.625C4.88866 14.0417 4.39199 13.3437 4.05199 12.531C3.71199 11.7183 3.54199 10.8953 3.54199 10.062C3.54199 8.75667 3.88566 7.57267 4.57299 6.51C5.26033 5.448 6.17333 4.653 7.31199 4.125C7.54866 4.02767 7.75366 4.045 7.92699 4.177C8.10099 4.309 8.18799 4.507 8.18799 4.771C8.18799 4.89567 8.14599 5.02067 8.06199 5.146C7.97933 5.27067 7.88233 5.361 7.77099 5.417C6.88233 5.847 6.17733 6.47867 5.65599 7.312C5.13533 8.14534 4.87499 9.062 4.87499 10.062C4.87499 10.7013 4.99666 11.323 5.23999 11.927C5.48266 12.531 5.86099 13.09 6.37499 13.604L6.81199 14.042V12.521C6.81199 12.3403 6.88166 12.184 7.02099 12.052C7.15966 11.92 7.31233 11.854 7.47899 11.854C7.65966 11.854 7.81599 11.92 7.94799 12.052C8.07999 12.184 8.14599 12.3403 8.14599 12.521V15.604C8.14599 15.8127 8.06966 15.9967 7.91699 16.156C7.76433 16.316 7.57666 16.396 7.35399 16.396H4.27099Z",
    fill: "#587E85"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSync);
export default __webpack_public_path__ + "static/media/ico_sync.89de7bec421d9f509415fde2207f9ce3.svg";
export { ForwardRef as ReactComponent };